import { useQuery } from "react-query";
import { planApi } from "@/react/api";
import type { Plan } from "@circle-react/types";

interface UseFetchPlansProps {
  billing_cycle: string | null;
  billing_currency: string | null;
  locale: string | null;
}

interface UseQueryFetchPlans {
  plans: Plan[];
  isRefetchingPlans: boolean;
}
interface UseFetchPlansResult extends UseQueryFetchPlans {
  isPlansLoading: boolean;
  isRefetchingPlans: boolean;
  errorFetchingPlans: any; // [TODO][BillingReactification][AfterRelease] Create error type
  refetchPlans: any;
}
export const useFetchPlans = ({
  billing_cycle,
  billing_currency,
  locale,
}: UseFetchPlansProps): UseFetchPlansResult => {
  const {
    data,
    isLoading: isPlansLoading,
    error: errorFetchingPlans,
    refetch: refetchPlans,
    isRefetching: isRefetchingPlans,
  } = useQuery<UseQueryFetchPlans, Error>(
    ["plans", billing_cycle, billing_currency, locale],
    () => planApi.fetchPlans({ billing_cycle, billing_currency, locale }),
    { enabled: !!billing_cycle },
  );

  const plans = data?.plans ?? [];

  return {
    plans,
    isPlansLoading,
    errorFetchingPlans,
    refetchPlans,
    isRefetchingPlans,
  };
};
